import { formatters } from 'services';

import type { NewAFSBondIssue } from './types';

export const formatAFSBondIssueTitle = (issue: NewAFSBondIssue): string => {
  const countryCode = issue.country_code?.trim();
  const countryCodeIsMissing =
    !countryCode || ['n/a', 'none', 'null'].includes(countryCode.toLowerCase());
  const maturityIsMissing =
    issue.maturity_years == null ||
    !Number.isFinite(issue.maturity_years) ||
    issue.maturity_years <= 0;
  const label =
    countryCodeIsMissing || maturityIsMissing
      ? issue.ticker
      : `${countryCode} ${issue.maturity_years}Y`;

  return `New ${label} Bond issue`;
};

export const formatAFSBondIssueDetails = (issue: NewAFSBondIssue): string =>
  [
    issue.coupon === null || issue.coupon === undefined
      ? null
      : `Coupon ${formatters.commas2Digits(issue.coupon)}%`,
    issue.yield === null || issue.yield === undefined
      ? null
      : `Yield ${formatters.commas3Digits(issue.yield)}%`,
    issue.dv01 === null || issue.dv01 === undefined
      ? null
      : `DV01 ${formatters.commas2Digits(issue.dv01)}`,
  ]
    .filter((detail): detail is string => Boolean(detail))
    .join(' · ');
